import React, { Component, createElement } from 'react';
import { message as AntMessage } from 'antd';

import { ComponentsManager, services } from '@comall-backend-builder/core';
import { localStorage  } from '@comall-backend-builder/core/lib/services';

interface LiveRoomInfoProps {
    params: any;
    componentId: string;
}

interface LiveRoomInfoStates {
    /**
     * 直播间数据
     */
    info: any;
    /**
     * 当前tab
     */
    defaultActiveKey: string;
}

export class LiveRoomInfo extends Component<LiveRoomInfoProps, LiveRoomInfoStates> {

    constructor(props: any) {
        super(props);

        this.state = {
            info: localStorage.get('LIVE_ROOM_INFO'), 
            defaultActiveKey: '1'
        };
    }

    componentWillMount() {
        const { params: { roomid, activeTab } } = this.props;
        const { info } = this.state;
        if (!info || (info && info.roomid !== Number(roomid))) {
            AntMessage.error('未找到直播间，请重新进入');
            setTimeout(() => {
                services.navigation.goto('/live-room');
            }, 1000);
        }
        this.setState({
            defaultActiveKey: activeTab
        });
    }

    componentWillUnmount() {
        localStorage.remove('LIVE_ROOM_INFO');
    }

    render() {
        const { componentId, params } = this.props;
        const { info, defaultActiveKey } = this.state;

        const items = [
            {
                title: '直播间信息',
                content: {
                    component: 'LiveRoomDetail',
                },
            },
        ];

        if (info && (info.liveStatus === 101 || info.liveStatus === 102)) {
            items.push({
                title: '导入商品',
                content: {
                    component: 'LiveRoomAddProductPage',
                },
            });
        }
        
        items.push({
            title: '直播间商品',
            content: {
                component: 'LiveRoomProducts',
            },
        });

        const tabsProps = {
            componentId,
            params,
            cache: false,
            items,
            defaultActiveKey
        };
        return createElement(ComponentsManager.get('Tabs'), tabsProps)
    };
}
